import {
    TOW_DRIVERS_FILTER_UPDATE,
} from '../../mutation-types';

export function setFilter(context, filter) {
    context.commit(TOW_DRIVERS_FILTER_UPDATE, filter);
}